import React, { useCallback, useEffect } from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames/bind';
import { useAppDispatch } from '../../hooks/useAppDispatch';
import { useAppSelector } from '../../hooks/useAppSelector';
import { organizerSlice } from '../../store/slice/slice';
import { Chat } from '../chat/Chat';
import { useStyles } from './chatList.styles';

export const ChatList = ({ noticePages }: any): JSX.Element => {
  const conversationId = useAppSelector((state) => state.organizerReducer.conversationId);
  const classes = useStyles();
  const cx = classNames.bind(classes);
  const dispatch = useAppDispatch();

  useEffect(() => {}, [conversationId]);

  const chatClassName = (id: number) => cx({
    chat: id !== (typeof conversationId === 'string' ? parseInt(conversationId) : conversationId),
    chatFocused: id === (typeof conversationId === 'string' ? parseInt(conversationId) : conversationId),
  });

  const textClassName = (id: number) => cx({
    chatSmallText: id !== (typeof conversationId === 'string' ? parseInt(conversationId) : conversationId),
    isHovered: id === (typeof conversationId === 'string' ? parseInt(conversationId) : conversationId),
  });

  const handleClick = useCallback((id: string) => () => {
    dispatch(organizerSlice.actions.setConversationId(id));
  }, [dispatch]);

  return (
    <div className={classes.chatList}>
      {
        noticePages.length
          ? noticePages.map((item: any) => (
            <Link
              key={item.id}
              to={`/notice?id=${item.id}`}
              className={classes.link}
              onClick={handleClick(item.id)}
            >
              <Chat
                item={item}
                className={chatClassName(item.id)}
                textClassName={textClassName(item.id)}
              />
            </Link>
          ))
          : <div className={classes.errorMessage}
          >No notice page
          </div>
      }
    </div>
  );
};
